import React, { Suspense, lazy } from 'react';
import type { CustomField } from '@puckeditor/core';

import type { VideoPoster, VideoSource } from '../../components/video-source';

const VideoSourceWidget = lazy(() => import('./video-source-widget'));
const VideoPosterWidget = lazy(() => import('./video-poster-widget'));

type VideoSourceFieldProps = {
  field: { label?: string };
  name: string;
  value?: VideoSource | null;
  onChange: (value: VideoSource) => void;
  readOnly?: boolean;
};

type VideoPosterFieldProps = {
  field: { label?: string };
  name: string;
  value?: VideoPoster | null;
  onChange: (value: VideoPoster) => void;
  readOnly?: boolean;
};

function VideoSourceFieldRender(props: VideoSourceFieldProps): JSX.Element {
  return (
    <Suspense fallback={null}>
      <VideoSourceWidget {...props} />
    </Suspense>
  );
}

function VideoPosterFieldRender(props: VideoPosterFieldProps): JSX.Element {
  return (
    <Suspense fallback={null}>
      <VideoPosterWidget {...props} />
    </Suspense>
  );
}

export const videoSourceField: CustomField<VideoSource> = {
  type: 'custom',
  label: 'Video source',
  render: VideoSourceFieldRender as CustomField<VideoSource>['render'],
  ai: { exclude: true },
};

export const videoPosterField: CustomField<VideoPoster> = {
  type: 'custom',
  label: 'Poster image',
  render: VideoPosterFieldRender as CustomField<VideoPoster>['render'],
  ai: { exclude: true },
};
